import PhotoEditor from "./PhotoEditor";

export default PhotoEditor;
